module.exports = __webpack_public_path__ + "static/media/iconModuleView.ed0bd402.svg";